import React, { Component } from "react";
import "./Home.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HomeVideo from "../../components/Home/HomeVideo";
import FullScreenInfoOne from "../../components/Home/FullScreenInfoOne";
import FullScreenInfoTwo from "../../components/Home/FullScreenInfoTwo";
import LatestFSInfo from "../../components/Home/LatestFSInfo";
import HomeCollections from "../../components/Home/HomeCollections";

import data from "../../data/data";

class Home extends Component {
  render() {
    return (
      <div className="Home">
        <LatestFSInfo data={data.LatestFSInfo} />
        <HomeVideo data={data.homeVideo} />
        <HomeCollections data={data.homeCollections} />
        <FullScreenInfoOne data={data.fullScreenInfoOne} />
        <FullScreenInfoTwo data={data.fullScreenInfoTwo} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(Home));



// WEBPACK FOOTER //
// ./src/views/Home/index.js